export var MSIEDirective = [
    '$window',
    function ($window) {
        return {
            link: function ($scope, $element) {
                var userAgent = $window.navigator.userAgent;
                var isIe = userAgent.indexOf('MSIE ') > -1;
                var isTrident = userAgent.indexOf('Trident') > -1;
                if (isIe || isTrident) {
                    $element.addClass('msie');
                }
            },
            restrict: 'A',
        };
    },
];
